<template>
  <div>
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="toggleDrawer"></v-app-bar-nav-icon>

      <v-toolbar-title>{{ title }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom name="notifications">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="openNotificationsDrawer" v-bind="attrs" v-on="on">
            <v-badge :content="sidebarNotifications['notifications']" :value="sidebarNotifications['notifications']"
              color="error" overlap>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Notificações</span>
      </v-tooltip>

      <v-tooltip bottom name="profile">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="goToProfilePage">
            <v-icon v-bind="attrs" v-on="on">
              mdi-account
            </v-icon>
          </v-btn>
        </template>
        <span>Perfil</span>
      </v-tooltip>

      <v-tooltip bottom name="theme">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="toggleDarkTheme" v-bind="attrs" v-on="on">
            <v-icon>
              mdi-brightness-{{ myDarkTheme ? '5' : '4' }}
            </v-icon>
          </v-btn>
        </template>
        <span>Tema {{ myDarkTheme ? 'claro' : 'escuro' }}</span>
      </v-tooltip>

      <v-tooltip bottom name="logout">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="logout" v-bind="attrs" v-on="on">
            <v-icon>
              mdi-logout
            </v-icon>
          </v-btn>
        </template>
        <span>Sair</span>
      </v-tooltip>
    </v-app-bar>

    <notifications-drawer :open="notification" :on-close="onNotificationsDrawerClose" />
  </div>
</template>

<script>
import { mapState } from "vuex"
import NotificationsDrawer from '@/components/NotificationsDrawer'

export default {
  name: "AppBar",
  components: {
    NotificationsDrawer
  },
  computed: {
    ...mapState({
      mini: state => state.layout.mini,
      darkTheme: state => state.layout.darkTheme,
      title: state => state.layout.currentRouteTitle,
      user: state => state.auth.user,
      sidebarNotifications: state => state.layout.sidebarNotifications,
      notifications: state => state.notifications.all,
    })
  },
  methods: {
    openNotificationsDrawer() {
      this.notification = true
      //this.notificationsCounters['notifications'] = 0
      this.$store.dispatch('layout/updateSidebarNotifications', this.notificationsCounters)
    },
    onNotificationsDrawerClose() {
      this.notification = false
    },
    toggleDrawer() {
      this.$store.dispatch('layout/toggleMini')
    },
    toggleDarkTheme() {
      this.$vuetify.theme.dark = !this.myDarkTheme
      this.$store.dispatch('layout/toggleDarkTheme', !this.myDarkTheme)
      this.myDarkTheme = !this.myDarkTheme
    },
    logout() {
      this.$store.dispatch('auth/logout')
    },
    goToProfilePage() {
      this.$router.push('/profile')
    },
  },
  watch: {
    sidebarNotifications: function (notifications) {
      this.notificationsCounters = JSON.parse(JSON.stringify(notifications))
    }
  },
  created() {
    this.$vuetify.theme.dark = this.darkTheme
    this.myDarkTheme = this.darkTheme
  },
  data: () => ({
    notificationsCounters: {},
    menu: false,
    notification: false,
    myDarkTheme: false,
  })
}
</script>
